/* ==== MM / Sélecteur de taille — JS =========================================
   Desktop : panneau flottant ancré au champ, bascule haut/bas selon la
   place visible. Mobile : bottom sheet déplacée sur <body> à l'ouverture —
   overlay pleine page, insensible aux transforms des conteneurs parents
   (sliders, cartes animées…).

   Seuil de bascule sheet configurable par instance :
     <div class="mm-dd" data-sheet-breakpoint="990">
   750px par défaut. C'est ce seuil (lu ici) qui ajoute/retire la classe
   .is-sheet sur le panneau et le backdrop — le CSS ne contient aucun
   media query pour ce comportement, donc CSS et JS ne peuvent jamais
   diverger. Utile quand un composant parent (ex. le comparateur) a son
   propre seuil « mobile » différent des 750px par défaut : il suffit de
   poser data-sheet-breakpoint pour que le dropdown suive le même seuil.

   Variante page produit (panneau .mm-dd__panel--product) : la sheet reste
   ouverte à la sélection (le CTA panier conclut), le prix du CTA se met à
   jour avec un pop, la croix ferme. Ouverture possible depuis n'importe
   quel bouton : <button data-dd-open="#Dd-123">Choisir la taille</button>. */
   (function () {
	'use strict';
  
	function initDropdown(dd) {
	  /* garde d'idempotence : initAll peut repasser sur un dd deja branche
		 (editeur de theme, section rechargee en ajax) — sans elle, chaque
		 passage empilerait un second jeu de listeners sur les memes options. */
	  if (dd._mmDdInit) return;
	  dd._mmDdInit = true;

	  var trigger = dd.querySelector('.mm-dd__trigger');
	  var value = dd.querySelector('[data-dd-value]');
	  var badge = dd.querySelector('[data-dd-badge]');
	  var options = dd.querySelectorAll('.mm-dd__option');
	  var panel = dd.querySelector('.mm-dd__panel');
	  var backdrop = dd.querySelector('.mm-dd__backdrop');
	  var closeBtn = panel && panel.querySelector('.mm-dd__close');
	  var ctaPrice = panel && panel.querySelector('[data-dd-price]');
	  var isProduct = !!(panel && panel.classList.contains('mm-dd__panel--product'));
	  /* CTA interne réellement rendu (dd_hide_cta='true' le masque) : seul ce
		 bouton peut conclure la sélection en sheet produit, sinon rien ne
		 ferme jamais le panneau et l'utilisateur reste coincé après avoir
		 choisi sa taille (cas PDP/quick-add, sans CTA interne). */
	  var hasInternalCta = !!(panel && panel.querySelector('.mm-dd__cta'));
	  var placeholder = document.createComment('mm-dd-panel');
	  var breakpoint = parseInt(dd.getAttribute('data-sheet-breakpoint'), 10) || 750;
	  var isInline = dd.classList.contains('mm-dd--inline');
  
	  function isSheetMode() { return window.innerWidth < breakpoint && !isInline; }
  
	  function syncMode() {
		var sheet = isSheetMode();
		/* variante inline (sticky CTA) : sous le seuil, pas de sheet — la liste
		   s'affiche à plat dans le panneau hôte (.is-flat), le champ reprend la
		   main au-dessus du seuil */
		if (isInline) {
		  var flat = window.innerWidth < breakpoint;
		  dd.classList.toggle('is-flat', flat);
		  /* applyOpenState plutôt que toggle : syncMode est appelé DEPUIS
			 toggle, un aller-retour rouvrirait le panneau dans la foulée */
		  if (flat && dd.classList.contains('is-open')) applyOpenState(false);
		}
		dd.classList.toggle('is-sheet', sheet);
		if (panel) panel.classList.toggle('is-sheet', sheet);
		if (backdrop) backdrop.classList.toggle('is-sheet', sheet);
		return sheet;
	  }
	  syncMode();
	  window.addEventListener('resize', syncMode);
  
	  /* la sheet vit sur <body> le temps de l'ouverture : un position:fixed
		 reste piégé dans tout ancêtre transformé (hover, drag, reveal…) */
	  function portalize() {
		if (!panel || panel.parentElement === document.body) return;
		dd.insertBefore(placeholder, panel);
		document.body.appendChild(panel);
		if (backdrop) document.body.appendChild(backdrop);
	  }
	  function unportalize() {
		if (!panel || panel.parentElement !== document.body) return;
		dd.insertBefore(panel, placeholder);
		dd.removeChild(placeholder);
		if (backdrop) dd.insertBefore(backdrop, dd.firstChild);
	  }
  
	  /* desktop : le panneau s'ouvre EN DESSOUS du champ, et ne bascule au-dessus
		 que si la place manque en dessous ET qu'il y en a davantage au-dessus.
		 Aucune préférence n'est écrite dans le markup : la mesure est refaite à
		 CHAQUE ouverture, donc le même champ s'ouvre vers le bas en haut de page
		 et vers le haut en bas de page. C'est la logique partagée des sélecteurs
		 du kit (MmMotion.autoFlip) ; repli local identique si mm-motion.js
		 n'est pas chargé. */
	  function autoFlip() {
		if (!panel || isSheetMode() || dd.classList.contains('is-flat')) return;
		if (window.MmMotion && MmMotion.autoFlip) {
		  MmMotion.autoFlip(trigger, panel, { upClass: 'mm-dd__panel--up' });
		  return;
		}
		/* dans un mm-panel (ex. quick-add), la place se mesure dans son body
		   scrollable, et le panneau y est plafonné pour défiler lui-même au lieu
		   d'allonger le scroll du body */
		var scroller = dd.closest('.mm-panel__body');
		var box = scroller ? scroller.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };
		var r = trigger.getBoundingClientRect();
		panel.style.removeProperty('--mm-dd-max-h');
		var h = panel.offsetHeight || 300;
		var spaceUp = r.top - Math.max(box.top, 0) - 16;
		var spaceDown = Math.min(box.bottom, window.innerHeight) - r.bottom - 16;
		var up = spaceDown < h && spaceUp > spaceDown;
		panel.classList.toggle('mm-dd__panel--up', up);
		if (scroller) panel.style.setProperty('--mm-dd-max-h', (up ? spaceUp : spaceDown) + 'px');
	  }
  
	  var returnTo = null;

	  function applyOpenState(open) {
		var focusInside = !open && panel && panel.contains(document.activeElement);
		dd.classList.toggle('is-open', open);
		if (panel) panel.classList.toggle('is-open', open);
		if (backdrop) backdrop.classList.toggle('is-open', open);
		trigger.setAttribute('aria-expanded', open);
		lockPage(open);
		if (!focusInside) return;
		var back = returnTo && document.contains(returnTo) && returnTo.getClientRects().length ? returnTo : trigger;
		returnTo = null;
		if (back.getClientRects().length) back.focus({ preventScroll: true });
	  }

	  /* fige la page derrière le panneau ouvert, sheet mobile comme panneau
		 desktop : data-lenis-prevent rend la liste défilable, mais sans ce
		 verrou la page continuait de défiler dès que le curseur sortait du
		 panneau. Lenis doit être arrêté en plus de l'overflow : il traduit la
		 molette en scroll programmatique, que overflow:hidden ne bloque pas.
		 La compensation est mesurée après coup — selon la plateforme, masquer
		 le défilement ne libère pas toujours de largeur (barres en surimpression). */
	  function lockPage(open) {
		var html = document.documentElement;

		/* On arrête l'INSTANCE, pas LenisManager : sa méthode stop() pose en plus
		   .stop-scrolling (overflow hidden), ce qui retire la barre de défilement
		   alors que html garde son scrollbar-gutter réservé — laissant une bande
		   vide à droite. Arrêtée, l'instance continue d'annuler la molette : la
		   page reste figée sans rien changer à la mise en page. */
		if (window.LenisManager && window.LenisManager.instance) {
		  if (open) window.LenisManager.instance.stop();
		  else window.LenisManager.instance.start();
		  return;
		}

		/* Repli sans Lenis (mobile) : le gutter est neutralisé avec le défilement,
		   puis la largeur réellement libérée est rendue en padding — sinon la même
		   bande vide apparaît, ou la page se décale. */
		if (open) {
		  var avant = html.clientWidth;
		  html.style.overflow = 'hidden';
		  html.style.scrollbarGutter = 'auto';
		  var libere = html.clientWidth - avant;
		  if (libere > 0) html.style.paddingRight = libere + 'px';
		} else {
		  html.style.overflow = '';
		  html.style.scrollbarGutter = '';
		  html.style.paddingRight = '';
		}
	  }
  
	  function toggle(force) {
		var open = typeof force === 'boolean' ? force : !dd.classList.contains('is-open');
  
		if (!open) {
		  applyOpenState(false);
		  return;
		}
  
		if (syncMode()) {
		  /* le tout premier portalize() déplace le panneau vers <body> :
			 s'il fallait transitionner dans la foulée sans lire de propriété
			 de layout entre les deux, le navigateur fusionne souvent le
			 déplacement et l'ouverture en un seul repaint et saute
			 l'animation. Lire offsetHeight force un reflow synchrone qui
			 fige l'état « fermé » comme point de départ de la transition —
			 seulement nécessaire cette première fois (ensuite le panneau
			 reste sur <body> d'un usage à l'autre, donc plus jamais de
			 déplacement à ce moment-là). */
		  var firstPortal = panel && panel.parentElement !== document.body;
		  portalize();
		  if (firstPortal) void panel.offsetHeight;
		} else {
		  unportalize();
		  autoFlip();
		}
  
		returnTo = panel && panel.contains(document.activeElement) ? returnTo : document.activeElement;
		applyOpenState(true);

		if (panel && panel.parentElement === document.body) {
		  var target = panel.querySelector('.mm-dd__option.is-selected') || panel.querySelector('.mm-dd__option, .mm-dd__close');
		  if (target) target.focus({ preventScroll: true });
		}
	  }
  
	  trigger.addEventListener('click', function () { toggle(); });
  
	  /* ouverture depuis n'importe quel bouton (usage page produit) */
	  if (dd.id) {
		document.querySelectorAll('[data-dd-open="#' + dd.id + '"]').forEach(function (btn) {
		  btn.addEventListener('click', function () { toggle(true); });
		});
	  }
  
	  if (backdrop) backdrop.addEventListener('click', function () { toggle(false); });
	  if (closeBtn) closeBtn.addEventListener('click', function () { toggle(false); });
  
	  /* Reflète une option choisie dans CE dropdown (trigger + is-selected +
		 badge + prix CTA), sans toucher au radio caché — utilisé pour le
		 clic local ET pour la resynchro venant d'une autre instance (voir
		 le listener data-dd-radio plus bas). */
	  function applyOption(option) {
		options.forEach(function (o) { o.classList.remove('is-selected'); });
		option.classList.add('is-selected');
		if (value) value.textContent = option.getAttribute('data-value');

		/* badge (mm_badges) : reflete dans le trigger celui de l'option choisie —
		   clone le HTML deja rendu par mm-label cote option plutot que de
		   reconstruire le composant en JS (une seule source de verite visuelle). */
		if (badge) {
		  var optionBadge = option.querySelector('.mm-dd__badge');
		  badge.innerHTML = optionBadge ? optionBadge.outerHTML : '';
		}

		/* variante page produit : prix du CTA mis à jour avec un pop */
		var price = option.getAttribute('data-price');
		if (price && ctaPrice) {
		  ctaPrice.textContent = price;
		  if (window.MmMotion) MmMotion.pop(ctaPrice);
		}

		/* Événement externe : un composant hôte (ex. le comparateur) peut
		   avoir besoin de réagir au choix — l'atome ne connaît pas ce qu'il
		   contient au-delà de son propre trigger/badge/prix CTA. */
		dd.dispatchEvent(new CustomEvent('mm:change', {
		  bubbles: true,
		  detail: { value: option.getAttribute('data-value'), option: option }
		}));
	  }

	  options.forEach(function (option) {
		option.addEventListener('click', function () {
		  if (option.getAttribute('aria-disabled') === 'true') return;
		  applyOption(option);
  
		  /* page produit : coche le radio caché consommé par VariantSelector
			 (mm_main_product.js) — son 'change' met à jour le variant du form
			 panier (id, URL, prix, media) via le mécanisme déjà en place pour
			 le variant-picker natif. */
		  var radioId = option.getAttribute('data-dd-radio');
		  if (radioId) {
			var radio = document.getElementById(radioId);
			if (radio && !radio.checked) {
			  radio.checked = true;
			  radio.dispatchEvent(new Event('change', { bubbles: true }));
			}
		  }

		  /* sheet produit avec CTA interne : on reste ouvert, c'est le CTA
			 panier qui conclut. Sinon (pas de CTA visible pour conclure), la
			 sélection ferme elle-même le panneau. */
		  if (!(isProduct && isSheetMode() && hasInternalCta)) {
			window.setTimeout(function () { toggle(false); }, 420);
		  }
		});
	  });

	  /* Resynchro inter-instances : quand une AUTRE instance du même produit
		 (form principal / sticky) coche un radio partagé (même id, dérivé de
		 product.id — voir mm-size-selector.liquid), ce dropdown-ci reflète le
		 même choix sans attendre un rechargement. Écouté sur chaque radio
		 référencé ici ; ne réagit qu'aux changements venant d'ailleurs
		 (l'option correspondante n'est pas déjà sélectionnée), donc pas de
		 boucle avec le clic local ci-dessus. */
	  options.forEach(function (option) {
		var radioId = option.getAttribute('data-dd-radio');
		if (!radioId) return;
		var radio = document.getElementById(radioId);
		if (!radio) return;
		radio.addEventListener('change', function () {
		  if (!radio.checked || option.classList.contains('is-selected')) return;
		  applyOption(option);
		});
	  });

	  document.addEventListener('click', function (e) {
		if (!dd.classList.contains('is-open')) return;
		if (dd.contains(e.target)) return;
		if (panel && panel.contains(e.target)) return;
		if (backdrop && backdrop.contains(e.target)) return;
		if (dd.id && e.target.closest && e.target.closest('[data-dd-open="#' + dd.id + '"]')) return;
		toggle(false);
	  });
	  document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && dd.classList.contains('is-open')) toggle(false);
	  });
	}
  
	function initAll(root) {
	  (root || document).querySelectorAll('.mm-dd').forEach(initDropdown);
	}

	/* expose pour les hotes qui injectent un .mm-dd apres coup (ex. la section
	   promo qui recharge sa carte via la Section Rendering API) */
	window.MmSizeSelector = { init: initAll };

	initAll(document);
	document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
  